import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Typography, Box } from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { blue, grey } from "@mui/material/colors";
import { CompactCustomerChip } from "../../../styled/pos/windows11";
import { setShowCustomerForm } from "../../../../store/actions/newOrderSlice";

/**
 * CompactCustomerInfo - Compact customer display for command bar
 *
 * States:
 * - Empty: Shows "+ Adicionar Cliente" with PersonAddIcon
 * - Filled: Shows avatar + customer name
 *
 * Click behavior: Opens customer form (dispatches setShowCustomerForm(true))
 */
const CompactCustomerInfo = ({ iconOnly }) => {
  const dispatch = useDispatch();
  const customer = useSelector((state) => state.newOrder.customer);

  const handleClick = () => {
    dispatch(setShowCustomerForm(true));
  };

  // Empty state
  if (!customer) {
    return (
      <CompactCustomerChip filled={false} onClick={handleClick}>
        <PersonAddIcon sx={{ fontSize: "1.25rem", color: grey[600] }} />
        {!iconOnly && (
          <Typography variant="body2" sx={{ fontWeight: 500, color: grey[700] }}>
            Adicionar Cliente
          </Typography>
        )}
      </CompactCustomerChip>
    );
  }

  // Filled state
  const initials = customer.name
    ? customer.name
        .split(" ")
        .slice(0, 2)
        .map((word) => word[0])
        .join("")
        .toUpperCase()
    : "?";

  return (
    <CompactCustomerChip filled={true} onClick={handleClick}>
      <Avatar
        sx={{
          bgcolor: blue[500],
          width: 32,
          height: 32,
          fontSize: "0.875rem",
          fontWeight: 600,
        }}
      >
        {initials}
      </Avatar>
      {!iconOnly && (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: blue[900],
              lineHeight: 1.2,
              maxWidth: 140,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {customer.name}
          </Typography>
          <Typography variant="caption" sx={{ color: blue[700], lineHeight: 1 }}>
            Cliente
          </Typography>
        </Box>
      )}
    </CompactCustomerChip>
  );
};

export default CompactCustomerInfo;
